// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"ManageUsers_overlayWrapper__XNOiP","viewBox":"ManageUsers_viewBox__laL+c","tablestyle":"ManageUsers_tablestyle__XX5I+"};